import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import ClearIcon from "@mui/icons-material/Clear";
import { Search } from "lucide-react";

const GroupStatementTable = ({ tableData }) => {
  console.log("tableData in Group table:", tableData);
  const [searchAccountTerm, setSearchAccountTerm] = useState("");
  const [filteredTableData, setFilteredTableData] = useState(tableData);
  const [viewMore, setViewMore] = useState(false);

  useEffect(() => {
    setFilteredTableData(tableData || []);
  }, [tableData]);

  useEffect(() => {
    if (!searchAccountTerm) {
      setFilteredTableData(tableData || []);
      return;
    }
    const term = searchAccountTerm.toLowerCase();
    const searchedTableData = tableData?.filter((row) =>
      Object.values(row).some(
        (val) =>
          val != null &&
          String(val).toLowerCase().includes(term),
      ),
    );
    setFilteredTableData(searchedTableData);
  }, [searchAccountTerm, tableData]);

  const clearSearch = () => setSearchAccountTerm("");


    const debitTotal = filteredTableData?.reduce(
    (sum, row) => sum + Number(row.DEBIT || 0),
    0
  );

  const creditTotal = filteredTableData?.reduce(
    (sum, row) => sum + Number(row.CREDIT || 0),
    0
  );

  return (
    <div className="pr-2">
      {/* Search + Totals + View More */}
      <div className="flex justify-between items-center">
        <div className="relative ml-4 mb-6 flex justify-between items-center border border-gray-300 pr-1 rounded w-[50%] bg-white rounded-lg outline-none ">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            className="pl-10 pr-4 my-2 ml-2 w-full rounded-lg outline-none border-none focus:outline-none focus:ring-0"
            type="text"
            placeholder="Search here ..."
            value={searchAccountTerm}
            onChange={(e) => setSearchAccountTerm(e.target.value)}
          />
          {searchAccountTerm !== "" && (
            <button
              className="absolute right-3 rounded text-gray-800"
              onClick={clearSearch}
            >
              <ClearIcon fontSize="small" />
            </button>
          )}
        </div>

        <p>
          <span className="text-sm">Total Balance : </span>
          <span className="text-lg font-semibold w-40 px-2 py-1 text-right">
            {/* {filteredTableData
              ?.reduce((acc, row) => acc + Number(row.BALANCE || 0), 0)
              .toFixed(2)} */}
               {(debitTotal - creditTotal).toFixed(2)}
          </span>
        </p>

        {/* <button
          onClick={() => setViewMore(!viewMore)}
          className="mt-2 px-3 py-1 bg-blue-500 text-white rounded-md text-sm"
        >
          {viewMore ? "View Less" : "View More"}
        </button> */}
      </div>

      {/* Scrollable Table */}
      <div className="overflow-y-auto max-h-[72vh] border rounded-lg">
        <table className="min-w-full table-auto border-collapse">
          <thead className="bg-gray-100 sticky top-0 z-10">
            <tr>
              <th className="border pl-1 text-sm text-left w-[125px] font-normal">
                Account
              </th>
              <th className="border pl-1 text-sm text-left w-[125px] font-normal">
                Name
              </th>
              <th className="border pl-1 text-sm text-left w-[125px] font-normal">
                Date
              </th>
              <th className="border pl-1 text-sm text-left font-normal">
                Type
              </th>
              <th className="border pl-1 text-sm text-left w-[125px] font-normal">
                Ref
              </th>
              <th className="border pl-1 text-sm text-left font-normal">
                Description
              </th>
              <th className="border pl-1 text-sm text-left font-normal">
                Debit
              </th>
              <th className="border pl-1 text-sm text-left font-normal">
                Credit
              </th>
              <th className="border pl-1 text-sm text-left font-normal">
                Balance
              </th>
            </tr>
          </thead>

          <tbody className="bg-white">
            {filteredTableData?.length > 0 ? (
              filteredTableData.map((row, idx) => (
                <tr key={idx}>
                  <td className="text-sm border px-3 py-2">{row.ACCOUNT}</td>
                  <td className="text-sm border px-3 py-2">{row.NAME}</td>
                  <td className="text-sm border px-3 py-2">
                    {dayjs(row.date).format("DD-MMM-YYYY")}
                  </td>
                  <td className="text-sm border px-3 py-2">{row.type}</td>
                  <td
                    className="text-sm border px-3 py-2 max-w-[125px] truncate"
                    title={row.ref}
                  >
                    {row.ref}
                  </td>
                  <td className="text-sm border px-3 py-2 max-w-[425px]">
                    {row.DESCRIPTION}
                  </td>
                  <td className="text-sm border px-3 py-2 text-right">
                    {Number(row.DEBIT).toFixed(2)}
                  </td>
                  <td className="text-sm border px-3 py-2 text-right">
                    {Number(row.CREDIT).toFixed(2)}
                  </td>
                  <td className="text-sm border px-3 py-2 text-right">
                    {Number(row.BALANCE).toFixed(2)}
                  </td>
                </tr>
              ))
            ) : (
              <tr className="h-[69vh]">
                <td
                  colSpan={viewMore ? 15 : 7}
                  className="text-center text-gray-400 border h-[100%]"
                >
                  <Search className="w-12 h-12 text-gray-300 mb-3 mx-auto" />
                  <p className="text-lg font-medium text-gray-900 mb-1">
                    No data found
                  </p>
                  <p className="text-sm text-gray-500">
                    Try a different Account
                  </p>
                </td>
              </tr>
            )}

            {/* Totals Row */}
            <tr className="bg-gray-100 sticky bottom-0 z-10">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td className="text-sm w-40 px-1 py-1 text-right">
                <span className="text-xs">Total Debit : </span>
                <span className="font-semibold">
                  {/* {filteredTableData
                    ?.reduce((acc, row) => acc + Number(row.DEBIT || 0), 0)
                    .toFixed(2)} */}
                     {debitTotal.toFixed(2)}
                </span>
              </td>
              <td className="text-sm w-40 px-2 py-1 text-right">
                <span className="text-xs">Total Credit : </span>
                <span className="font-semibold">
                  {/* {filteredTableData
                    ?.reduce((acc, row) => acc + Number(row.CREDIT || 0), 0)
                    .toFixed(2)} */}
                      {creditTotal.toFixed(2)}
                </span>
              </td>
              <td className="text-sm w-40 px-2 py-1 text-right">
                <span className="text-xs">Total Balance : </span>
                <span className="font-semibold">
                  {/* {filteredTableData
                    ?.reduce((acc, row) => acc + Number(row.BALANCE || 0), 0)
                    .toFixed(2)} */}

                     {(debitTotal - creditTotal).toFixed(2)}
                </span>
              </td>
              {/* {viewMore && (
                <>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </>
              )} */}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GroupStatementTable;
